import { render } from "./TocLinks.vue?vue&type=template&id=39d4367c"
import script from "./TocLinks.vue?vue&type=script&lang=js"
export * from "./TocLinks.vue?vue&type=script&lang=js"

import "./TocLinks.vue?vue&type=style&index=0&id=39d4367c&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.24.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__